var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00448 5.05371H0.470852C0.210816 5.05371 0 5.26453 0 5.52456C0 5.7846 0.210816 5.99541 0.470852 5.99541H1.00448V5.05371Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00448 12.5879H0.470852C0.210816 12.5879 0 12.7987 0 13.0587C0 13.3188 0.210816 13.5296 0.470852 13.5296H1.00448V12.5879Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00448 10.0762H0.470852C0.210816 10.0762 0 10.287 0 10.547C0 10.8071 0.210816 11.0179 0.470852 11.0179H1.00448V10.0762Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00448 7.56543H0.470852C0.210816 7.56543 0 7.77625 0 8.03628C0 8.29632 0.210816 8.50713 0.470852 8.50713H1.00448V7.56543Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00448 2.54297H0.470852C0.210816 2.54297 0 2.75378 0 3.01382C0 3.27386 0.210816 3.48467 0.470852 3.48467H1.00448V2.54297Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01834 0H2.41744C1.63856 0 1.00488 0.633673 1.00488 1.41256V2.5426H2.48022C2.74025 2.5426 2.95107 2.75342 2.95107 3.01345C2.95107 3.27349 2.74025 3.4843 2.48022 3.4843C2.05168 3.4843 1.466 3.4843 1.00488 3.4843V5.05381H2.48022C2.74025 5.05381 2.95107 5.26463 2.95107 5.52466C2.95107 5.7847 2.74025 5.99552 2.48022 5.99552C1.71562 5.99552 2.16255 5.99552 1.00488 5.99552V7.56502H2.48022C2.74025 7.56502 2.95107 7.77584 2.95107 8.03587C2.95107 8.29591 2.74025 8.50673 2.48022 8.50673C2.05168 8.50673 1.466 8.50673 1.00488 8.50673V10.0762H2.48022C2.74025 10.0762 2.95107 10.287 2.95107 10.5471C2.95107 10.8071 2.74025 11.0179 2.48022 11.0179C1.71562 11.0179 2.16255 11.0179 1.00488 11.0179V12.5874H2.48022C2.74025 12.5874 2.95107 12.7983 2.95107 13.0583C2.95107 13.3183 2.74025 13.5291 2.48022 13.5291C2.05168 13.5291 1.466 13.5291 1.00488 13.5291V14.6592C1.00488 15.4381 1.63856 16.0717 2.41744 16.0717H4.01834V0Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94141 3.48438H10.0759V4.55164H7.94141V3.48438Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5878 0H4.95996V16.0717H12.5878C13.3666 16.0717 14.0003 15.4381 14.0003 14.6592V1.41256C14.0003 0.633673 13.3666 0 12.5878 0ZM11.0183 5.02242C11.0183 5.28246 10.8074 5.49327 10.5474 5.49327H7.47117C7.21114 5.49327 7.00032 5.28246 7.00032 5.02242V3.01345C7.00032 2.75342 7.21114 2.5426 7.47117 2.5426H10.5474C10.8074 2.5426 11.0183 2.75342 11.0183 3.01345V5.02242Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/Address.35439639f6238e96bb724c3e0f36c076.svg";
export { ForwardRef as ReactComponent };